/**
 * The System — single source of truth for the /how-it-works "System" page AND
 * the Functional Landscape PDF (`backend/make_functional_landscape.py`), which
 * reads the SAME `system360.json`. One data file powers every surface — page,
 * grid, mobile view, catalogue and the leave-behind PDF — so they can never
 * drift. That is the System of Proof discipline turned inward on our own site.
 *
 * Display rule: `short` is the primary display name (nav, chips, matrix cells,
 * body copy). `full` is the scoping name shown as a subtitle on first use.
 * The matrix grid uses short labels only.
 */
import data from "./system360.json";

export const PHASES = data.phases;
export const LENS_ORDER = data.lens_order;
export const SERVICE_LINES = data.service_lines;
export const STREAMS = data.streams;
export const MATRIX = data.matrix;
export const MATRIX_LEGEND = data.matrix_legend;
export const ASSURANCE = data.assurance;
export const REGISTRY_DECISIONS = data.registry_decisions;
